module.exports = __webpack_public_path__ + "img/22.43e588ca.jpg";